import { config } from "@/config";
export const DepartamentoService = {
    async getById(id) {
        const response = await fetch(`${config.API_URL}/api/Departamento/${id}`);
        if (!response.ok)
            throw new Error(`Error al obtener departamento con id ${id}`);
        const result = await response.json();
        return result.datos;
    },
    async getAll() {
        const response = await fetch(`${config.API_URL}/api/Departamento`);
        if (!response.ok)
            throw new Error("Error al obtener departamentos");
        const result = await response.json();
        if (!result.datos || !Array.isArray(result.datos))
            return [];
        return result.datos;
    },
    async add(departamento) {
        const response = await fetch(`${config.API_URL}/api/Departamento`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(departamento),
        });
        if (!response.ok)
            throw new Error("Error al agregar departamento");
    },
    async update(id, departamento) {
        const response = await fetch(`${config.API_URL}/api/Departamento/${id}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(departamento),
        });
        if (!response.ok)
            throw new Error("Error al actualizar departamento");
    },
    async delete(id) {
        const response = await fetch(`${config.API_URL}/api/Departamento/${id}`, {
            method: "DELETE",
        });
        if (!response.ok) {
            let msg = "Error al eliminar departamento";
            try {
                const err = await response.json();
                if (err.message)
                    msg = err.message;
            }
            catch (_) { }
            throw new Error(msg);
        }
    },
    async exportReport(request) {
        try {
            const response = await fetch(`${config.API_URL}/api/Departamento/export`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                },
                body: JSON.stringify(request),
            });
            if (!response.ok)
                throw new Error("Error al exportar el reporte de departamentos");
            const format = request.format || "excel";
            const extension = format === "pdf" ? "pdf" : "xlsx";
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            const timestamp = new Date()
                .toISOString()
                .replace(/[:.]/g, "-")
                .slice(0, 19);
            link.setAttribute("download", `Departamentos_${timestamp}.${extension}`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
        catch (error) {
            console.error("Error al exportar el reporte:", error);
            throw error;
        }
    },
    async toggleActivo(id) {
        const response = await fetch(`${config.API_URL}/api/Departamento/${id}/toggle-activo`, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
        });
        if (!response.ok)
            throw new Error("No se pudo cambiar el estado del departamento");
    },
};
